import {Component} from "@angular/core";
import {MatDialogRef, MatDialogContent} from "@angular/material/dialog";
import {TranslateService, TranslatePipe} from "@ngx-translate/core";
import {TranslatableComponent} from "../../../core/models/TranslatableComponent";
import {CdkScrollable} from "@angular/cdk/scrolling";
import {MatIcon} from "@angular/material/icon";
import {MatFormField} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";

@Component({
	selector: "app-favorite-resource-request-dialog",
	templateUrl: "./favorite-resource-request-dialog.component.html",
	styleUrls: ["./favorite-resource-request-dialog.component.scss"],
	imports: [
		CdkScrollable,
		MatDialogContent,
		MatIcon,
		MatFormField,
		MatInput,
		ReactiveFormsModule,
		FormsModule,
		TranslatePipe,
	],
})
export class FavoriteResourceRequestDialogComponent extends TranslatableComponent {
	comment: string = "";

	constructor(
		public dialogRef: MatDialogRef<FavoriteResourceRequestDialogComponent>,
		public _translate: TranslateService,
	) {
		super(_translate, "ConfirmationDialogComponent");
		this.dialogRef.addPanelClass("mep-info-dialog");
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	onSave(): void {
		this.dialogRef.close(this.comment);
	}
}
